export default [{
    header: 'Visitas',
    icon: 'MapPinIcon',
    children: [
        {
            title: 'Lista',
            route: 'visits-list',
            icon: 'ListIcon',
            action: 'manage',
		    resource: 'visits'
        }
    ]
}];